import { isActiveMembership } from "helpers/membership-helpers";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useSubscriptionRejoinUrl } from "hooks/use-subscription-rejoin-url";
import BuyAddToBagButton from "./buyAddToBag";
import ProspectAddToBagButton from "./prospectAddToBag";
import SubscriptionAddToBagButton from "./subscriptionAddToBag";

export default function AddToBag({ availability, availabilityLoaded, membershipError, selectedSize, isBuy }) {
  const membershipState = useSelector(state => state.membershipState);
  const userData = useSelector(state => state.userData);
  const addresses = userData?.userProfile?.addresses;
  const staticProduct = useSelector(state => state.staticProduct);
  const isProspect = !isActiveMembership(membershipState);
  const { userCanRejoin, rejoinUrl } = useSubscriptionRejoinUrl();

  const selectedSizeAvailability =
    availabilityLoaded && availability?.find(availability => availability?.sku === selectedSize?.sku);

  // Assume available until availability has loaded
  const styleUnavailable = availabilityLoaded && !availability?.find(el => el.availableCount > 0);
  const selectSizeIsUnavailable =
    selectedSize && (!selectedSizeAvailability || !selectedSizeAvailability.availableCount);

  if (isBuy) {
    return (
      <BuyAddToBagButton
        addresses={addresses}
        selectedSize={selectedSize}
        styleUnavailable={styleUnavailable}
        selectSizeIsUnavailable={selectSizeIsUnavailable}
        staticProduct={staticProduct}
      />
    );
  } else if (isProspect) {
    return (
      <ProspectAddToBagButton
        availability={availability}
        selectedSize={selectedSize}
        membershipState={membershipState}
        userCanRejoin={userCanRejoin}
        rejoinUrl={rejoinUrl}
      />
    );
  } else {
    return (
      <SubscriptionAddToBagButton
        addresses={addresses}
        selectedSize={selectedSize}
        staticProduct={staticProduct}
        styleUnavailable={styleUnavailable}
        selectSizeIsUnavailable={selectSizeIsUnavailable}
        availabilityLoaded={availabilityLoaded}
        membershipError={membershipError}
      />
    );
  }
}

AddToBag.propTypes = {
  availability: PropTypes.array,
  selectedSize: PropTypes.object,
  availabilityLoaded: PropTypes.bool,
  membershipError: PropTypes.object,
  isBuy: PropTypes.bool,
};
